define.alias("shared/components/shared/social/instagram-modal/available-page", "preview-grid/components/shared/social/instagram-modal/available-page");